import StatusMessage from '../StatusMessage';
import FadeoutMessage from '../FadeoutMessage';
import ErrorIcon from '~/assets/icons/error.svg?react';
import { useNetworkStatusStore } from '~/stores/networkStateStore';
import useNetworkStatus from '~/hooks/useNetworkStatus';
import styles from './NetworkStatusMessage.module.scss';

export default function NetworkStatusMessage() {
  const { isBackendOnline, wasBackendPreviouslyOnline, secondsUntilNextPing, networkLostText } =
    useNetworkStatusStore();
  const [isOnline, networkPreviouslyOnline] = useNetworkStatus();

  const getMessage = () => {
    if (!isOnline) {
      return (
        // Inline this icon since it won't load if the network is down
        <StatusMessage status="error" icon={<ErrorIcon />}>
          <div>Internetanslutning saknas. Vänligen kontrollera din anslutning.</div>
          {networkLostText && <div>{networkLostText}</div>}
        </StatusMessage>
      );
    }

    if (isOnline && !networkPreviouslyOnline) {
      return (
        <FadeoutMessage>
          <StatusMessage status="success">Internetanslutning återställd</StatusMessage>
        </FadeoutMessage>
      );
    }

    if (isOnline && !isBackendOnline) {
      return (
        <StatusMessage status="error">
          <div>Kan inte nå Friskas server. {`Försöker igen om ${secondsUntilNextPing} sekunder.`}</div>
        </StatusMessage>
      );
    }

    if (isBackendOnline && !wasBackendPreviouslyOnline) {
      return (
        <FadeoutMessage>
          <StatusMessage status="success">Kontakt med Friskas server återställd.</StatusMessage>
        </FadeoutMessage>
      );
    }
  };

  return <div className={styles.wrapper}>{getMessage()}</div>;
}
